import {
  FormLayout,
  Panel,
  PanelSection,
  PanelHeader,
  PanelTitle,
  PanelDescription,
  FormLayoutGroup,
} from '@customerio/pluma-components/react';
import { TextField, withForm } from '@/components/form';
import { formOpts } from '../helpers/form';

export const PlatformsInfo = withForm({
  ...formOpts,
  props: {
    canEdit: true,
  },
  render: function PlatformsInfo({ form, canEdit }) {
    return (
      <Panel>
        <PanelHeader>
          <PanelTitle>Platform availability</PanelTitle>
          <PanelDescription>
            Add URLs to your app or service on different platforms where users can access it
          </PanelDescription>
        </PanelHeader>
        <PanelSection>
          <FormLayout>
            <FormLayoutGroup gap="300" display="grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
              <TextField
                name="iosUrl"
                api={form}
                label="iOS"
                placeholder="App Store or TestFlight link"
                icon="apple"
                isDisabled={canEdit === false}
              />
              <TextField
                name="androidUrl"
                api={form}
                label="Android"
                placeholder="Play Store or APK download link"
                icon="android"
                isDisabled={canEdit === false}
              />
            </FormLayoutGroup>
            <FormLayoutGroup gap="300" display="grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
              <TextField
                name="macUrl"
                api={form}
                label="Mac"
                placeholder="Mac App Store or download link"
                icon="desktop"
                isDisabled={canEdit === false}
              />
              <TextField
                name="windowsUrl"
                api={form}
                label="Windows"
                placeholder="Microsoft Store or download link"
                icon="desktop"
                isDisabled={canEdit === false}
              />
            </FormLayoutGroup>
            <FormLayoutGroup gap="300" display="grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
              <TextField
                name="webUrl"
                api={form}
                label="Web app"
                placeholder="Web application URL"
                icon="browser"
                isDisabled={canEdit === false}
              />
              <TextField
                name="browserExtensionUrl"
                api={form}
                label="Browser extension"
                placeholder="Extension store or download link"
                icon="browser"
                isDisabled={canEdit === false}
              />
            </FormLayoutGroup>
            <FormLayoutGroup gap="300" display="grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
              <TextField
                name="apiUrl"
                api={form}
                label="API"
                placeholder="API documentation or endpoint URL"
                icon="api-credentials"
                isDisabled={canEdit === false}
              />
            </FormLayoutGroup>
          </FormLayout>
        </PanelSection>
      </Panel>
    );
  },
});
